import { myTags } from "../../basic/path";
import RequestModel from "../../basic/requestConfig";

export default {
    getFavTagsByLevel(vue, query) {
        return new Promise((resolve, reject) => {
            let requestModel = new RequestModel({
                method: 'get',
                url: myTags.getFavTagsByLevel,
                data: query.data ? query.data : {},
                params: query.params ? query.params : {}
            }),
            request = requestModel.tokenConfig();
            vue.axios(request).then(function (result) {
                resolve(result);
            })
        });
    },
    getFavTagsByName(vue, query) {
        return new Promise((resolve, reject) => {
            let requestModel = new RequestModel({
                method: 'get',
                url: myTags.getFavTagsByName,
                data: query.data ? query.data : {},
                params: query.params ?  query.params: {}
            }),
            request = requestModel.tokenConfig();
            vue.axios(request).then(function (result) {
                resolve(result)
            })
        })
    },
    updateFavTag(vue, query) {
        return new Promise((resolve, reject) => {
            let requestModel = new RequestModel({
                method: 'get',
                url: myTags.updateFavTag,
                data: query.data ? query.data : {},
                params: query.params ? query.params : {}
            }),
            request = requestModel.tokenConfig();
            vue.axios(request).then(function (result) {
                resolve(result)
            })
        })
    },
}
